import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './registerServiceWorker'
import store from './store'
import 'vue-material-design-icons/styles.css'

Vue.config.productionTip = false

router.beforeEach((to, from, next) => {
  store.commit('closeNav')
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!store.state.auth) {
     next({
       path: '/login',
       query: { redirect: to.fullPath }
     })
   } else {
     next()
   }
 } else {
   next()
 }
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
